import React from 'react'
import ProtectionPage from '../protection'

const ProtectionPageEn = () => {
    return <ProtectionPage languageCode="en" />
}

export default ProtectionPageEn
